<template>
  <div>
    <el-dialog
      title="参数"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
    >
      <div>
        <el-button
          style="margin-bottom: 10px"
          type="primary"
          icon="el-icon-magic-stick"
          @click="formatCode()"
          >{{ this.isFormat ? "美化" : "还原" }}</el-button
        >
      </div>
      <el-form
        ref="form"
        class="json-text"
        :model="form"
        label-width="0px"
        size="mini"
        style="width: 950px; height: 550px"
      >
        <el-form-item label="" prop="parameter">
          <el-input
            v-model="form.parameter"
            disabled
            type="textarea"
            :rows="30"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
// 本弹窗名称
const DialogName = "ChildActivityConfigParameterDialog";

export default {
  data() {
    return {
      form: {},
      tmpFormParameter: "",
      isFormat: true,
    };
  },

  created() {
    let value = this.$dialogutil.getData(DialogName);
    this.form = value.info;
    this.tmpFormParameter = value.info.parameter;
  },

  components: {},

  methods: {
    formatCode() {
      if (this.isFormat) {
        let tmpObj = JSON.parse(this.tmpFormParameter);
        this.form.parameter = JSON.stringify(tmpObj, null, "    ");
      } else {
        this.form.parameter = this.tmpFormParameter;
      }
      this.isFormat = !this.isFormat;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #000000;
  cursor: not-allowed;
}
.paramCls {
  background-color: #080808;
  border-color: #e4e7ed;
  color: #000000;
}
</style>

